// RoutesContext.ts
import { createContext } from 'react';
import { appRoutes } from '../../routes';

export type RoutesContextType = {
  routes: typeof appRoutes;
  setLanguage: (language: string) => void;
};

export const RoutesContext = createContext<RoutesContextType>({
  routes: appRoutes,
  setLanguage: () => {},
});